// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedProducts_container__XjCy8","title":"FeaturedProducts_title__XKJrC","wrapper":"FeaturedProducts_wrapper__Aj41N","image":"FeaturedProducts_image__MAeZK"};